import { GAME_ID, REDUX_ACTIONS } from 'a/pickyGoblins/data/constants';
import { getProgressAtLevelStart, getQuestionsPerLevel } from '../../lib/utilityFunctions';

const initialState = {
  draggingItem: false,
  currentLevel: 0,
  highlightedLevel: 0,
  progress: 0,
  answersCorrect: 0,
  lipButtonDisabled: true,
  practiceIndices: {
    a: 0,
    b: 0,
    c: 0,
    'c (s)': 0,
    'c (ca, co, cu)': 0, // spanish  letter
    ch: 0, // spanish letter
    d: 0,
    e: 0,
    f: 0,
    g: 0,
    'g (gue/gui)': 0, // spanish  letter
    'g (a, o, u)': 0, // spanish  letter
    'g (e, i)': 0, // spanish  letter
    h: 0,
    i: 0,
    j: 0,
    k: 0,
    l: 0,
    ll: 0,
    m: 0,
    n: 0,
    ñ: 0,
    o: 0,
    p: 0,
    q: 0,
    'q (k)': 0, // spanish letter
    r: 0,
    rr: 0,
    'r (medial)': 0, // spanish letter
    s: 0,
    t: 0,
    u: 0,
    v: 0,
    w: 0,
    x: 0,
    y: 0,
    'y (final)': 0, // spanish letter
    z: 0,
  },
};

const levelReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INCREMENT_PROGRESS:
      return {
        ...state,
        progress: state.progress + 1,
      };

    case REDUX_ACTIONS.INCREMENT_CORRECT_ANSWER:
      return {
        ...state,
        answersCorrect: state.answersCorrect + 1,
      };

    case REDUX_ACTIONS.DEV_SET_ALL_ANSWERS_CORRECT:
      return {
        ...state,
        answersCorrect: getQuestionsPerLevel()[state.currentLevel],
      };

    case REDUX_ACTIONS.RESET_CORRECT_ANSWER:
      return {
        ...state,
        answersCorrect: 0,
      };

    case REDUX_ACTIONS.SET_PROGRESS:
      return {
        ...state,
        progress: payload,
      };

    case REDUX_ACTIONS.START_LEVEL:
      return {
        ...state,
        currentLevel: payload.level,
        progress: getProgressAtLevelStart(payload.level),
      };

    case REDUX_ACTIONS.INCREMENT_LEVEL_HIGHLIGHT:
      return {
        ...state,
        highlightedLevel: state.currentLevel + 1,
      };

    case REDUX_ACTIONS.DEV_INCREMENT_LEVEL_HIGHLIGHT_ALL:
      return {
        ...state,
        currentLevel: payload,
        highlightedLevel: state.currentLevel + 1,
      };

    case REDUX_ACTIONS.UPDATE_PRACTICE_ROUND: {
      // each new time a specific sound needs to be practiced,
      // queue up a new practice item. Loop as necessary.
      let currentIndex = state.practiceIndices[payload];
      if (currentIndex < 3) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }

      const practiceIndices = Object.assign(state.practiceIndices);
      practiceIndices[payload] = currentIndex;

      return {
        ...state,
        practiceIndices,
      };
    }

    case REDUX_ACTIONS.UPDATE_DRAGGING_ITEM:
      return {
        ...state,
        draggingItem: payload,
      };

    case REDUX_ACTIONS.SET_LIP_BUTTON_DISABLED:
      return {
        ...state,
        lipButtonDisabled: payload,
      };

    default:
      return state;
  }
};

export default levelReducer;
